import styled, { css } from "styled-components";
const LIGHT_CALLOUT_THEME = {
  bg: "#FFFFFF",
  line: "rgba(15, 23, 42, 0.10)",
  title: "#0F172A",
  body: "#334155",
  icon: "#475569",
  eyebrow: "#1D5BD8",
  dot: "#CBD5E1",
  dotActive: "#1D5BD8",
  shadow: "0 1px 2px rgba(0, 0, 0, 0.25), 0 16px 40px rgba(0, 0, 0, 0.45)"
};
const DARK_CALLOUT_THEME = {
  bg: "#111A2E",
  line: "rgba(255, 255, 255, 0.14)",
  title: "#F1F5F9",
  body: "#CBD5E1",
  icon: "#CBD5E1",
  eyebrow: "#8AB6FF",
  dot: "#3B4A6B",
  dotActive: "#8AB6FF",
  shadow: "0 1px 2px rgba(15, 23, 42, 0.20), 0 16px 40px rgba(15, 23, 42, 0.30)"
};
export const calloutThemeFor = (mode) => mode === "dark" ? DARK_CALLOUT_THEME : LIGHT_CALLOUT_THEME;
export const Card = styled.div(
  ({ theme, $c }) => css`
    position: relative;
    width: 380px;
    box-sizing: border-box;
    padding: 18px 20px 16px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: ${$c.bg};
    border: 1px solid ${$c.line};
    box-shadow: ${$c.shadow};
    font-family: ${theme.fonts.family.body};

    button {
      font-family: inherit;
      cursor: pointer;
    }

    button:focus-visible {
      outline: 3px solid #6ea8ff;
      outline-offset: 2px;
    }
  `
);
const arrowBase = css`
  position: absolute;
  width: 16px;
  height: 16px;
  transform: rotate(45deg);
  background: ${({ $c }) => $c.bg};
`;
export const Arrow = styled.div(
  ({ $c, $placement, $offset }) => {
    const border = `1px solid ${$c.line}`;
    const horizontal = $offset === void 0 ? "calc(50% - 8px)" : `${$offset}px`;
    switch ($placement) {
      case "top":
        return css`
          ${arrowBase};
          left: ${horizontal};
          bottom: -9px;
          border-right: ${border};
          border-bottom: ${border};
        `;
      case "left":
        return css`
          ${arrowBase};
          top: 28px;
          right: -9px;
          border-top: ${border};
          border-right: ${border};
        `;
      case "right":
        return css`
          ${arrowBase};
          top: 28px;
          left: -9px;
          border-bottom: ${border};
          border-left: ${border};
        `;
      case "none":
        return css`
          display: none;
        `;
      case "bottom":
      default:
        return css`
          ${arrowBase};
          left: ${horizontal};
          top: -9px;
          border-left: ${border};
          border-top: ${border};
        `;
    }
  }
);
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -6px -10px -2px 0;
`;
export const Eyebrow = styled.div(
  ({ $c }) => css`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${$c.eyebrow};
  `
);
export const CloseButton = styled.button(
  ({ $c }) => css`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: ${$c.icon};
  `
);
export const Title = styled.div(
  ({ $c }) => css`
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: ${$c.title};
  `
);
export const Body = styled.p(
  ({ $c }) => css`
    margin: 0;
    font-size: 15px;
    line-height: 23px;
    color: ${$c.body};
  `
);
export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
`;
export const Dots = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const Dot = styled.span(
  ({ $c, $active }) => css`
    height: 6px;
    border-radius: 3px;
    width: ${$active ? 18 : 6}px;
    background: ${$active ? $c.dotActive : $c.dot};
  `
);
export const Actions = styled.div`
  display: flex;
  gap: 6px;
`;
export const SkipButton = styled.button(
  ({ $c }) => css`
    height: 44px;
    padding: 0 14px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: ${$c.body};
    font-size: 15px;
    font-weight: 500;
  `
);
export const NextButton = styled.button(
  ({ $accent }) => css`
    height: 44px;
    padding: 0 16px 0 18px;
    border: 0;
    border-radius: 8px;
    background: ${$accent};
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
  `
);
